import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';

export default function MultipleSelectCheckmarks({
  optionsConfig,
  label,
  setPersonName,
  personName,
}) {

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div style={{ position: 'relative', zIndex: 1700 }}>
      <FormControl sx={{ m: 1, width: 400 }}>
        <InputLabel id="demo-multiple-checkbox-label">{label}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          single
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Atributo" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={{ style: { zIndex: 1755, width:250,  maxHeight: 48 * 4.5 + 8, } }}
        >
          {optionsConfig.map((name) => (
            <MenuItem key={name} value={name}>
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
